import React, { useState } from "react";
import { SchemaWorkflow } from "../components/SchemaWorkflow";
import { ValidationScreen } from "../components/ValidationScreen";
import { ConfirmationScreen } from "../components/ConfirmationScreen";
import ComingSoon from "app/components/common/ComingSoon";

const schema = {
  id: "fee",
  name: "Fee Mapping",
  description: "Update fee structure, concessions, and payment plans",
  columns: [
    { name: "Admission Number", type: "text", required: true },
    { name: "Session", type: "text", required: true },
    { name: "Fee Structure", type: "text" },
    { name: "Concession Type", type: "text" },
    { name: "Concession Percentage", type: "number" },
  ],
};

export default function FeeInfo({ onBack }) {
  const IsComingSoon= true;
  const [currentStep, setCurrentStep] = useState("upload");
  const [uploadedData, setUploadedData] = useState([]);
  const [validationResults, setValidationResults] = useState(null);
  const [updateResults, setUpdateResults] = useState(null);

  const handleFileValidated = (data, results) => {
    setUploadedData(data);
    setValidationResults(results);
    setCurrentStep("validation");
  };

  const handleProceed = () => {
    const results = {
      total: validationResults.total,
      valid: validationResults.valid,
      invalid: validationResults.invalid,
    };
    setUpdateResults(results);
    setCurrentStep("confirmation");
  };

  const handleBackToUpload = () => {
    setCurrentStep("upload");
    setValidationResults(null);
  };

  const handleBackToDashboard = () => {
    onBack();
  };
  if (IsComingSoon) {
    return <ComingSoon />;
  }
  if (currentStep === "upload") {
    return (
      <SchemaWorkflow
        schema={schema}
        onBack={handleBackToDashboard}
        onFileValidated={handleFileValidated}
      />
    );
  }

  if (currentStep === "validation" && validationResults) {
    return (
      <ValidationScreen
        schema={schema}
        data={uploadedData}
        validationResults={validationResults}
        onReupload={handleBackToUpload}
        onProceed={handleProceed}
      />
    );
  }

  if (currentStep === "confirmation" && updateResults) {
    return (
      <ConfirmationScreen
        results={updateResults}
        onBackToDashboard={handleBackToDashboard}
      />
    );
  }

  return null;
}
